import { Button, Modal, Form, Row, Col, ProgressBar } from "react-bootstrap";
import storageService from "../services/storage.service";
import { useTranslation } from 'react-i18next';
import appsettings from '../configs/appsettings.json';

export const ModalGeneralInformation = (props: any) => {
  const idiom = storageService.getIdiom();
  const { t } = useTranslation();

  const pathPdf = appsettings.PDF_URL + `/pdf/` + idiom.replaceAll('-', '') + `/` + props.pdfFileName;
 
  const title = (props.pdfFileName == "GeneralInformationDashboardBranch.pdf" ? t("MODAL_GENERAL_INFORMATION.TITLE_OPERATOR"): t("MODAL_GENERAL_INFORMATION.TITLE"));


  return (
    <>
    <Modal as={Modal.Dialog}  centered  show={props.show} onHide={props.close} fullscreen={true} >
        <Modal.Header>
          <Modal.Title className='h6'>{title}</Modal.Title>
          <Button variant='close' aria-label='Close' onClick={props.close} />
        </Modal.Header>
        <Modal.Body style={{height: 800}}>         
          <iframe src={pathPdf}
          frameBorder="0"
          scrolling="auto"
          height="100%"
          width="100%"
          ></iframe>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="primary" onClick={props.close}>{props.ButtonCloseLabel}</Button>      
      </Modal.Footer>
      </Modal>  
    </>
  );
};